import { API_ROOT } from '../../config/config'
import * as Api_ProposalGoal from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getProposalGoal = (id) => {
  const url = `${API_ROOT}/proposal/${id}/goal`
  return Api_ProposalGoal.doGet(url)
}

export const saveGoalTenYear = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/goal/strategy`
  return Api_ProposalGoal.doPost(url, request)
}

export const getGoalTenYear = (id) => {
  const url = `${API_ROOT}/proposal/${id}/strategy`
  return Api_ProposalGoal.doGet(url)
}

export const saveComplianceObjectives = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/goal/objective`
  return Api_ProposalGoal.doPost(url, request)
}

export const getComplianceObjectives = (id) => {
  const url = `${API_ROOT}/proposal/${id}/objective`
  return Api_ProposalGoal.doGet(url)
}
